<template>
  <div class="detail-page">
    <div class="detail-hero">
      <div class="hero-top">
        <button class="hero-back" @click="$router.push({ path: '/homePage' })">
          <img src="../assets/back.png" alt="">
        </button>
        <span class="hero-title">鹊桥会详情</span>
        <div class="hero-space"></div>
      </div>
      <div class="hero-desc">了解平台背景、介绍说明与服务愿景</div>
    </div>

    <div class="detail-content">
      <div class="detail-card">
        <div class="section-title">平台介绍</div>
        <div class="section-text intro-text">{{ introduction }}</div>
      </div>

      <div class="detail-card highlight-card">
        <div class="section-title">服务理念</div>
        <div class="section-text slogan-text">{{ INTRODUCTIONSLOGAN }}</div>
      </div>

      <div class="detail-card logo-card">
        <img :src="logo" alt="">
        <div class="logo-title">{{ logoTitle }}</div>
        <div class="logo-desc">官方指定婚恋交友平台，页面风格已统一为当前项目原型化视觉。</div>
      </div>
    </div>
  </div>
</template>
<script>
import logo from "../assets/LOGO.jpg";

export default {
  data() {
    return {
      logo,
      introduction: process.env.INTRODUCTION,
      INTRODUCTIONSLOGAN: process.env.INTRODUCTIONSLOGAN
    };
  },
  computed: {
    logoTitle() {
      return `${process.env.COMPANYNAME}鹊桥会`;
    }
  }
};
</script>
<style src="../style/detail.less" lang="less" scoped />



// WEBPACK FOOTER //
// src/views/detail.vue